<template>
    <div>
        <div v-if="loadingData" class="ix-sending-loader mt-2 mb-2">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des envois
        </div>

        <span class="mt-2 mb-2 d-block ix-text-secondary" v-if="sendings.length == 0 && !loadingData">Il n'y a pas d'envois
            associés</span>

        <div class="mt-2 mb-2">
            <div class="ix-sending-line" v-for="(sending, index) in sendings" :key="index">
                <div class="ix-sending-icon">
                    <span>
                        <i class="far fa-paper-plane" v-if="sending.type == 1"></i>
                        <i class="far fa-envelope-open-text" v-if="sending.type == 2"></i>
                        <i class="far fa-mailbox" v-if="sending.type == 3"></i>
                    </span>
                </div>
                <div class="ix-sending-line-content">
                    <button class="ix-btn link" @click="showSending(sending, index)" v-b-tooltip
                        :title="sending.state_label" v-html="truncate(sending.recipient, 50)"></button> <span
                        class="ix-state-badge" v-bind:class="sending.state_color"></span>
                        <span class="ix-text-secondary fs-4 font-italic" v-if="sending.sending_level && sending.is_reminder">R{{sending.sending_level}}</span>
                </div>
                <div class="ix-sending-line-date">
                    {{ sending.sended_at | formatDate('DD MMM YYYY') }}
                </div>
            </div>
        </div>

        <button class="ix-btn" @click="initSending()">Envoyer</button>

        <div class="modal fade" id="showSendingModal" tabindex="-1" aria-labelledby="showSendingModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-mail-bulk"></i> Détail de l'envoi</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="selectedSending">
                            <div class="ix-bloc-simple-line">
                                <h3 class="ix-bloc-simple-line-title">Type d'envoi</h3>
                                {{ selectedSending.type == 1 ?
                                    'Envoi automatisé' : (selectedSending.type == 2 ? 'Courrier suivi' : 'Autre: (' +
                                        selectedSending.method + ')')
                                }}
                            </div>
                            <div class="ix-bloc-simple-line"
                                v-if="selectedSending.tracking_number && selectedSending.type == 2">
                                <h3 class="ix-bloc-simple-line-title">Numéro de suivi</h3>
                                {{ selectedSending.tracking_number }}
                                <small class="form-text text-muted">Pour obtenir plus d'informations, accédez directement a
                                    <a href="https://www.laposte.fr/outils/suivre-vos-envois" target="_blank">l'outil de
                                        suivi La Poste</a></small>
                            </div>
                            <div class="ix-bloc-simple-line">
                                <h3 class="ix-bloc-simple-line-title">{{ selectedSending.type == 1 ? 'Contact' :
                                    (selectedSending.type == 2 ? 'Adresse' : 'Destinataire') }}</h3>
                                {{ selectedSending.recipient }}
                            </div>
                            <div class="ix-bloc-simple-line">
                                <h3 class="ix-bloc-simple-line-title">État</h3>
                                <span class="ix-state" v-bind:class="selectedSending.state_color">{{
                                    selectedSending.state_label }}</span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedSending.sended_at">
                                <h3 class="ix-bloc-simple-line-title">Date d'envoi</h3>
                                {{ selectedSending.sended_at | formatDate('DD MMMM YYYY') }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedSending.received_at">
                                <h3 class="ix-bloc-simple-line-title">Date de reception</h3>
                                {{ selectedSending.received_at | formatDate }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedSending.opened_at">
                                <h3 class="ix-bloc-simple-line-title">Date d'ouverture</h3>
                                {{ selectedSending.opened_at | formatDate }}
                            </div>

                            <div class="ix-bloc-simple-line"
                                v-if="selectedSending.documents.length && selectedSending.type == 1">
                                <h3 class="ix-bloc-simple-line-title">Documents joints</h3>
                                <ul class="m-0">
                                    <li v-for="document in selectedSending.documents" :key="document.id">{{ document.name
                                    }}.{{ document.extension }}</li>
                                </ul>
                            </div>

                            <div class="ix-bloc-simple-line" v-if="selectedSending.subject && selectedSending.type == 1">
                                <h3 class="ix-bloc-simple-line-title">Sujet</h3>
                                {{ selectedSending.subject }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedSending.message && selectedSending.type == 1">
                                <h3 class="ix-bloc-simple-line-title">Message</h3>
                                <span v-html="nl2br(selectedSending.message)"></span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer" v-show="admin">
                        <button type="button" class="ix-btn red" @click="deleteSending()"><i class="far fa-trash"></i>
                            Supprimer</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="initSendingModal" tabindex="-1" aria-labelledby="initSendingModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="far fa-mail-bulk"></i> Enregistrer un nouvel envoi</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="ix-comments-loader" v-if="loading">
                            <i class="far fa-circle-notch fa-spin"></i> Configuration des options d'envoi en cours
                        </div>

                        <div v-show="!loading">
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label for="sending-sended-at">Date</label>
                                        <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa"
                                            id="sending-sended-at" v-model="form.sended_at">
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label for="sending-type">Méthode</label>
                                        <select id="sending-type" class="form-control" v-model="form.type">
                                            <option value="1">Envoi automatisé</option>
                                            <option value="2">Courrier suivi (La Poste)</option>
                                            <option value="3">Autre</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            
                            <div class="row" v-if="(object && !loadingObject) && (object.is_due || object.sending_state)"> 
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="reminder" v-model="form.is_reminder"  v-bind:disabled="object.sending_state == false">
                                                <label class="form-check-label" for="reminder">
                                                    Relance <span class="ix-text-secondary"
                                                        v-if="object.sending_state == false">(Indisponible)</span>
                                                </label>
                                        </div>
                                    </div>
                                </div>    
                            </div>



                            <!-- Automatic -->
                            <div class="row" v-show="form.type == 1">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="">Choisissez les contacts</label>
                                        <table class="ix-table">
                                            <tbody>
                                                <tr v-for="(contact, index) in form.contacts" v-bind:key="index">
                                                    <td>
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox"
                                                                v-bind:disabled="!contact.email"
                                                                v-bind:id="'contact-' + index" v-model="contact.checked">
                                                            <label class="form-check-label" v-bind:for="'contact-' + index">
                                                                {{ contact.fullname }}
                                                                <span v-bind:class="{ 'text-muted': !contact.email }">{{
                                                                    contact.email ? contact.email : "Adressenonrenseignée"
                                                                }}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <small class="text-muted form-text" v-if="company_link">Un contact n'apparait pas ou
                                            une adresse est manquante ou incorrecte ? Rendez-vous sur la
                                            <a v-bind:href="company_link" target="_blank">fiche de la société</a> pour
                                            réaliser les modifications avant de rafraichir la liste des contacts</small>
                                        <button class="ix-btn link" v-bind:disabled="loadingContacts" @click="getOptions()">
                                            <span v-show="!loadingContacts"><i class="far fa-sync"></i> Rafraichir la liste
                                                des contacts</span>
                                            <span v-show="loadingContacts"><i class="far fa-circle-notch fa-spin"></i> Mise
                                                à jour des contacts</span>
                                        </button>
                                    </div>

                                    <div class="form-group" v-show="form.documents.length > 0">
                                        <label for="" v-b-tooltip :title="allowed_extensions_tooltip">Documents à joindre <i
                                                class="fas fa-question-circle"></i></label>

                                        <span class="d-block ix-text-secondary" v-if="form.documents.length > 5">{{
                                            selectedDocumentsCount }} document{{ selectedDocumentsCount > 1 ? 's' : '' }}
                                            sélectionné{{ selectedDocumentsCount > 1 ? 's' : '' }}</span>

                                        <div
                                            v-show="form.documents.length <= 5 || (form.documents.length > 5 && displayAllDocuments == true)">
                                            <table class="ix-table">
                                                <tbody>
                                                    <tr v-for="(document, index) in form.documents" v-bind:key="index">
                                                        <td>
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    v-bind:id="'document-' + index"
                                                                    v-model="document.checked">
                                                                <label class="form-check-label"
                                                                    v-bind:for="'document-' + index">
                                                                    {{ document.name }}.{{ document.extension }}
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <button class="ix-btn link mt-2 mb-2" @click="toggleDisplayAllDocuments()"
                                            v-if="form.documents.length > 5">
                                            <span v-if="displayAllDocuments == true"><i class="far fa-angle-up"></i>
                                                Masquer</span>
                                            <span v-if="displayAllDocuments == false"><i class="far fa-angle-down"></i>
                                                Afficher</span>
                                            les documents disponibles
                                        </button>
                                    </div>

                                    <div class="form-group" v-if="is_cgv_auto_merged !== null">
                                        <small class="form-text text-muted">
                                            <span v-if="is_cgv_auto_merged">Les conditions générales de vente seront automatiquement incluses dans le document.</span>
                                            <span v-else>Les conditions générales de vente ne sont pas incluses automatiquement dans ce document (réglable dans Paramètres &gt; Trade).</span>
                                        </small>
                                    </div>

                                    <div class="form-group" v-if="is_cgv_file_available">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="sending-cgv-file"
                                                v-model="form.is_cgv_attached">
                                            <label class="form-check-label" for="sending-cgv-file">
                                                Joindre les conditions générales de vente en pièce jointe distincte
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="is_cga_available !== null">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                v-bind:disabled="is_cga_available === false" id="sending-cga"
                                                v-model="form.is_cga_attached">
                                            <label class="form-check-label" for="sending-cga">
                                                Joindre les conditions générales d'achat <span class="ix-text-secondary"
                                                    v-if="is_cga_available === false">(Indisponible)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="" data-toggle="tooltip" data-placement="top"
                                            title="Ces destinataires ne seront pas ajoutés à la fiche société">Autres
                                            destinataires <i class="fas fa-question-circle"></i></label>
                                        <div class="input-group mb-2" v-for="(email, emailIndex) in form.emails"
                                            v-bind:key="emailIndex">
                                            <input type="text" class="form-control"
                                                @input="checkIfNewEmailNeeded(emailIndex)" v-model="email.email"
                                                :key="emailIndex">
                                            <div class="input-group-append">
                                                <button class="ix-btn ix-btn-icon transparent" type="button"
                                                    @click="deleteEmail(emailIndex)"><i class="far fa-trash"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <button class="ix-btn link mb-2" @click="addEmail()"><i class="far fa-plus"></i> Ajouter
                                        un destinataire</button>

                                    <div class="form-group">
                                        <label for="sending-subject">Sujet</label>
                                        <input type="text" class="form-control" id="sending-subject" v-model="form.subject">
                                    </div>

                                    <div class="form-group">
                                        <label for="sending-message">Message</label>
                                        <textarea id="sending-message" rows="5" class="form-control"
                                            v-model="form.message"></textarea>
                                    </div>

                                    <span v-if="identity.name" class="ix-text-secondary">L'email sera envoyé au nom de {{
                                        identity.name }} ({{ identity.email }})</span>
                                </div>
                            </div>

                            <!-- Tracked letter -->
                            <div class="row" v-show="form.type == 2">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="sending-tracking-number">Numéro de suivi</label>
                                        <input type="text" class="form-control" v-model="form.tracking_number"
                                            id="sending-tracking-number">
                                        <small class="form-text text-muted">Renseignez le n° de suivi de 11 à 15
                                            caractères</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="sending-address">Adresse</label>
                                        <input type="text" class="form-control" v-model="form.address" id="sending-address">
                                    </div>
                                </div>
                            </div>

                            <!-- Other -->
                            <div class="row" v-show="form.type == 3">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="sending-method">Précisez</label>
                                        <input type="text" class="form-control" v-model="form.method" id="sending-method">
                                    </div>

                                    <div class="form-group">
                                        <label for="sending-recipient">Destinataire</label>
                                        <input type="text" class="form-control" v-model="form.recipient"
                                            id="sending-recipient">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer" v-show="!loading">
                        <button v-if="object == null || object && object.number !== null" type="submit"
                            class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm" @click="send()">
                            <span v-if="!loadingForm">
                                <i class="far fa-paper-plane"></i>
                                Envoyer
                            </span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                        <button v-if="object && object.number === null" type="submit" class="ix-btn green"
                            v-bind:disabled="!checkForm() || loadingForm" @click="confirmSend()">
                            <span v-if="!loadingForm">
                                <i class="far fa-paper-plane"></i>
                                Envoyer
                            </span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Sendings",
    props: {
        sendableType: String,
        sendableId: Number,
        order: String, // normal or reverse
        admin: Number,
        objectUrl:"",
        url: "",
        autoOpenAfterMount: Boolean,
    },
    data() {
        return {
            loading: true,
            loadingForm: false,
            loadingContacts: false,
            loadingData: false,
            loadingObject: false,

            form: {
                type: 1,
                sended_at: this.moment().format('DD/MM/YYYY'),
                contacts: [],
                documents: [],
                emails: [],
                subject: '',
                message: '',
                tracking_number: '',
                address: '',
                method: '',
                recipient: '',
                is_cgv_attached: false,
                is_cga_attached: false,
                is_reminder: false
            },

            is_cgv_auto_merged: null,
            is_cgv_file_available: false,
            is_cga_available: false,
            allowed_extensions: [],
            displayAllDocuments: false,
            identity: [],

            selectedSending: null,
            selectedIndex: null,
            company_link: null,
            is_admin: this.admin || false,
            sendings: [],
            object: null,
        }
    },
    computed: {
        selectedDocumentsCount: function () {
            return this.form.documents.filter(document => { return document.checked }).length
        },
        allowed_extensions_tooltip: function () {
            var extensions = this.allowed_extensions.join(', ')
            var str = `Pour des raisons de sécurité, seuls les fichiers ${extensions} sont proposés`
            return str;
        },
    },
    methods: {
        toggleDisplayAllDocuments() {
            this.displayAllDocuments = !this.displayAllDocuments
        },
        async getData() {
            this.loadingData = true;
            fetch(this.url + "?sendable_type=" + this.sendableType + "&sendable_id=" + this.sendableId + "&orderBy=" + (this.order == 'normal' ? 'sended_at' : '!sended_at'), {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingData = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.sendings = data
                        
                    })
                }
            }).catch(error => {
                this.loadingData = false
            });
        },
        async getObject() {
            this.loadingObject = true;
            fetch(this.objectUrl+ "?id=" + this.sendableId , {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingObject = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.object = data;
                    })
                }
            }).catch(error => {
                console.log(error)
                this.loadingObject = false;
            });
        },


        async getOptions() {
            this.loadingContacts = true;
            fetch(this.url + "/options?sendable_type=" + this.sendableType + "&sendable_id=" + this.sendableId, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingContacts = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        //On stock les données pour pouvoir les utiliser dans le watch
                        this.subject_reminder = data.subject_reminder
                        this.message_reminder = data.message_reminder
                        this.subject = data.subject
                        this.message = data.message

                        if (!this.form.subject) {
                            this.form.subject = data.subject
                        }
                        if (!this.form.message) {
                            this.form.message = data.message
                        }
                        
                        if (!this.form.address) {
                            this.form.address = data.address
                        }

                        this.form.contacts = data.contacts

                        this.form.documents = data.documents
                        this.allowed_extensions = data.allowed_extensions
                        this.is_cgv_auto_merged = data.is_cgv_auto_merged
                        this.is_cgv_file_available = data.is_cgv_file_available

                        this.is_cga_available = data.is_cga_available
                        this.form.is_cga_attached = data.is_cga_attached
                        this.form.is_reminder = data.is_reminder

                        this.company_link = data.company_link
                        this.identity = data.identity
                    })
                }
            }).catch(error => {
                this.loadingContacts = false
                console.log(error)
            });
        },
        showSending(sending, index) {
            this.selectedSending = sending
            this.selectedIndex = index
            $('#showSendingModal').modal()
        },
        async initSending() {
            $('#initSendingModal').modal()
            this.loading = false
            await this.getOptions()
        },
        checkIfNewEmailNeeded: function (index) {
            if (this.form.emails.length > 0) {
                if (this.form.emails.length - 1 == index) {
                    this.addEmail()
                }
            }
        },
        addEmail() {
            this.form.emails.push({ email: '' })
        },
        deleteEmail(index) {
            this.form.emails.splice(index, 1)
        },
        checkForm() {
            if (this.form.type == 1) {
                var hasContactsChecked = this.form.contacts.filter(contact => { return contact.checked }).length > 0
                var hasEmailsFilled = this.form.emails.filter(contact => { return contact.email }).length > 0

                return (hasContactsChecked || hasEmailsFilled) && this.form.subject && this.form.message
            } else if (this.form.type == 2) {
                return this.form.tracking_number && this.form.address
            } else if (this.form.type == 3) {
                return this.form.method && this.form.recipient
            } else {
                return false
            }
        },
        async confirmSend() {
            this.$swal({
                title: "Etes-vous sûr ?",
                text: "Etes-vous sûr de vouloir envoyer le projet de facture ?",
                icon: "warning",
                buttons: ["Non", "Oui"],
            }).then((willDo) => {
                if (willDo) {
                    this.send();
                }
            });
        },
        async send() {
            this.loadingForm = true
            var data = {}

            data.sendable_type = this.sendableType
            data.sendable_id = this.sendableId
            data.type = this.form.type
            data.sended_at = this.form.sended_at
            data.subject = this.form.type == 1 ? this.form.subject : null
            data.message = this.form.type == 1 ? this.form.message : null
            data.tracking_number = this.form.type == 2 ? this.form.tracking_number : null
            data.method = this.form.type == 3 ? this.form.method : null
            data.is_cgv_attached = this.form.is_cgv_attached
            data.is_cga_attached = this.form.is_cga_attached
            data.is_reminder = this.form.is_reminder

            if (this.form.is_reminder){
                if (this.object.sending_level != null){
                    if (this.object.sending_level < 3){
                    data.sending_level = this.object.sending_level + 1
                    }
                }else {
                    data.sending_level = 1 
                }
            }

            data.recipients = []
            data.documents = []

            // Construction du tableau de destinataires
            if (this.form.type == 1) {
                this.form.contacts.forEach(function (contact) {
                    if (contact.checked) {
                        data.recipients.push(contact.email)
                    }
                })

                this.form.documents.forEach(function (document) {
                    if (document.checked) {
                        data.documents.push(document.id)
                    }
                })

                this.form.emails.forEach(function (contact) {
                    if (contact.email) {
                        data.recipients.push(contact.email)
                    }
                })
            } else if (this.form.type == 2) {
                data.recipients.push(this.form.address)
            } else if (this.form.type == 3) {
                data.recipients.push(this.form.recipient)
            }

            fetch(this.url, {
                ...{
                    method: 'POST',
                    body: JSON.stringify(data)
                },
                ...this.getHttpJsonRequestHeaders(),
            }).then((response) => {
                this.loadingForm = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.getData()
                        $('#initSendingModal').modal('hide');
                        this.object = null 
                    })
                }
            }).catch(error => {
                this.loadingForm = false
                console.log(error)
            });
        },
        async deleteSending() {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: "L'envoi sera définitivement supprimé",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    $('#showSendingModal').modal('hide');
                    this.sendings.splice(this.selectedIndex, 1)

                    this.loadingData = true
                    fetch(this.url + "/" + this.selectedSending.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        this.loadingData = false
                    }).catch(error => {
                        this.loadingData = false
                        console.log(error);
                    })
                }
            });
        },
    },
    watch: {
        'form.is_reminder': function (val) {
            if (val){
                switch(this.object.sending_level+1){
                    case 1:
                        this.form.subject = this.subject_reminder['1']
                        this.form.message = this.message_reminder['1']
                        break;
                    case 2:
                        this.form.subject = this.subject_reminder['2']
                        this.form.message = this.message_reminder['2']
                        break;
                    case 3:
                        this.form.subject = this.subject_reminder['3']
                        this.form.message = this.message_reminder['3']
                        break;
                    default:
                        this.form.subject = this.subject
                        this.form.message = this.message
                }
                
            } else {
                this.form.subject = this.subject
                this.form.message = this.message
            }
        
        }
    
    },
    async mounted() {
        $('.datepicker').change(function () {
            $(this)[0].dispatchEvent(new Event('input'));
        });
        this.addEmail()
        await this.getData()

  
        if(this.sendableType == 'App\\Models\\Quote' || this.sendableType == 'App\\Models\\Invoice'){
            await this.getObject()
        }

        if (this.autoOpenAfterMount) {
            await this.initSending()
        }
        
    }
    
}
</script>
